<div [formGroup]="formGroup()">
  <div class="resource-link position-relative">
    <mdb-form-control>
      <mdb-select
        [id]="id()"
        [filter]="true"
        [filterPlaceholder]="('SEARCH' | translate) + '...'"
        [notFoundMsg]="'NO_RESULTS_FOUND' | translate"
        [clearButton]="clearButton()"
        [multiple]="multiple()"
        [optionsSelectedLabel]="optionsSelectedLabel() | translate"
        [formControlName]="controlName()"
        [placeholder]="placeholder() ? (placeholder()! | translate) : null"
      >
        @for (option of searchService().models(); track option.id) {
          <mdb-option [value]="optionValueSelector() ? getOptionValue(option) : option">
            {{ getOptionLabel(option) }}
          </mdb-option>
        }
      </mdb-select>
      @if (!hideLabel()) {
        <label mdbLabel class="form-label" [for]="id()">
          {{ label() | translate }}{{ isRequired() ? ' *' : '' }}
        </label>
      }
      @if (searchService().loading().loading) {
        <div
          class="autocomplete-loader spinner-border"
          [class.custom-loading]="baseLink() && selectedLink"
          role="status"
        ></div>
      }
    </mdb-form-control>
    @if (isRequired() && control?.hasError('required') && (control?.touched || control?.dirty)) {
      <mdb-error>
        {{ label() | translate }} {{ 'VALIDATION.FROM_THE_LIST' | translate }}
        {{ 'VALIDATION.IS_REQUIRED' | translate }}.
      </mdb-error>
    }
    @if (control?.hasError('unselected') && (control?.touched || control?.dirty)) {
      <mdb-error>
        {{ 'VALIDATION.SELECT_FROM_LIST' | translate }}
      </mdb-error>
    }
    @if (baseLink() && selectedLink) {
      <a
        [href]="selectedLink"
        style="margin-top: 3px"
        target="_blank"
        class="link-icon"
      >
        <i class="fas fa-external-link text-primary"></i>
      </a>
    }
  </div>
</div>
